<template>
  <div class="banner">
    
    <div class="banner-left">
      <el-carousel style="height: 100%">
        <el-carousel-item v-for="(i, index) of $store.state.zt" :key="index">
          <a :href="i.body || '#'" target="_blank">
            <div class="banner-shadow"></div>
            <!-- 图片容器，添加相对定位 -->
            <div class="banner-image-container">
              <!-- 判断图片路径，为空时显示默认图片 -->
              <img :src="i.image || '/Public/home/images/default-tai.jpg'" />
              <!-- 默认文字，当图片路径为空时显示 -->
              <div class="default-text" v-if="!i.image">
                <h3>{{ i.title || "默认标题" }}</h3>
              </div>
            </div>
          </a>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="banner-right">
      <div class="banner-right-pc">
        <a
          v-for="(i, index) of $store.state.article"
          :key="index"
          :href="'/detail--' + i.id + '.html'"
          target="_blank"
        >
          <div class="banner-shadow"></div>
          <img
            :src="require('@/assets/' + ($store.state.random + index) + '.jpg')"
          />
          <p>{{ i.title }}</p>
        </a>
      </div>

      <ul class="banner-right-m">
        <li>
          <span>热点</span>
          <p>网经社</p>
        </li>
        <li>
          <el-carousel direction="vertical" indicator-position="none">
            <el-carousel-item
              v-for="(i, index) of $store.state.article"
              :key="index"
            >
              <a :href="'/detail--' + i.id + '.html'" target="_blank">
                {{ i.title }}</a
              >
            </el-carousel-item>
          </el-carousel>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
};
</script>

<style scoped>
/* 添加样式 */
.banner-image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.default-text {
  position: absolute;
  top: 20%;
  left: 50%;
  width: 82%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 2;
  /* background-color: rgba(0, 0, 0, 0.5); */
  padding: 12px;
  border-radius: 5px;
}

.default-text h3 {
  margin: 0 0 10px 0;
  font-size: 24px;
}

.default-text p {
  margin: 0;
  font-size: 16px;
}

/* 确保图片充满容器 */
.banner-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
